import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

function AboutPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation Header - Mismo estilo que Home */}
      <Header />

      {/* Hero Section - Mismo estilo que Home */}
      <section 
        className="relative py-24 lg:py-32 overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(/images/spanish.learn.webp)',
          backgroundColor: '#FEF9C3'
        }}
      >
        {/* Background Overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary-100/95 via-secondary-50/92 to-primary-50/95"></div>
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-primary-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary-300 rounded-full blur-3xl"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
          <h1 className="text-5xl md:text-7xl font-display font-bold text-gray-900 mb-6 leading-tight">
            About Vencejo Academy
          </h1>
          <h2 className="text-2xl md:text-4xl font-display font-semibold text-gray-700 mb-8">
            Transforming Spanish Learning Through Music, Culture, and Immersive Experiences
          </h2>
          <p className="text-xl text-gray-600 mb-10 max-w-3xl mx-auto">
            Your trusted partner in Spanish language learning
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
              Our Mission
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              At Vencejo Academy, we believe that learning Spanish should be fun, engaging, and culturally rich. 
              We're dedicated to helping English speakers master Spanish through authentic music, immersive 
              cultural experiences, interactive games, and comprehensive learning materials that make language 
              acquisition natural and enjoyable.
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
                Our Story
              </h2>
              <div className="space-y-4 text-gray-700 leading-relaxed">
                <p>
                  Vencejo Academy was born from a simple observation: traditional language learning methods often 
                  feel disconnected from real-world Spanish. We noticed that students were learning grammar 
                  rules but struggling to understand native speakers, cultural nuances, and authentic expressions.
                </p>
                <p>
                  Our founder, a passionate Spanish educator and cultural enthusiast, decided to create a 
                  different approach. By combining music, films, recipes, travel guides, and interactive 
                  content, we've built a platform that teaches Spanish the way it's actually spoken and lived.
                </p>
                <p>
                  Today, we've helped over 150,000 students improve their Spanish through our innovative 
                  learning materials. Our mission continues to evolve as we discover new ways to make 
                  language learning more accessible, enjoyable, and effective.
                </p>
              </div>
            </div>
            <div className="bg-gradient-to-br from-primary-50 to-secondary-50 rounded-2xl p-8 border border-primary-100">
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center">
                  <div className="text-4xl font-display font-bold text-primary-600 mb-2">150,000+</div>
                  <div className="text-gray-700">Books Sold</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-display font-bold text-secondary-600 mb-2">1,200+</div>
                  <div className="text-gray-700">Bundle Packs</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-display font-bold text-primary-600 mb-2">50+</div>
                  <div className="text-gray-700">Countries</div>
                </div>
                <div className="text-center">
                  <div className="text-4xl font-display font-bold text-secondary-600 mb-2">4.8/5</div>
                  <div className="text-gray-700">Average Rating</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
              Our Values
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              What drives us every day
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-primary-50 to-secondary-50 border border-primary-100">
              <div className="w-20 h-20 bg-gradient-to-r from-primary-600 to-secondary-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              </div>
              <h3 className="text-xl font-display font-semibold mb-3">Authenticity</h3>
              <p className="text-gray-600">
                We use real Spanish music, films, and cultural content created by native speakers.
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-secondary-50 to-primary-50 border border-secondary-100">
              <div className="w-20 h-20 bg-gradient-to-r from-secondary-600 to-primary-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              </div>
              <h3 className="text-xl font-display font-semibold mb-3">Effectiveness</h3>
              <p className="text-gray-600">
                Our methods are backed by language acquisition research and proven results.
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-primary-50 to-secondary-50 border border-primary-100">
              <div className="w-20 h-20 bg-gradient-to-r from-primary-600 to-secondary-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              </div>
              <h3 className="text-xl font-display font-semibold mb-3">Enjoyment</h3>
              <p className="text-gray-600">
                Learning should be fun! We make Spanish learning engaging and motivating.
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-secondary-50 to-primary-50 border border-secondary-100">
              <div className="w-20 h-20 bg-gradient-to-r from-secondary-600 to-primary-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              </div>
              <h3 className="text-xl font-display font-semibold mb-3">Support</h3>
              <p className="text-gray-600">
                We're here for you every step of the way with personalized tutor support.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Method Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
              Our Unique Approach
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Why our method works differently
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg border border-primary-100">
              <h3 className="text-2xl font-display font-bold mb-4">Music-Based Learning</h3>
              <p className="text-gray-700 leading-relaxed">
                Learn Spanish through authentic songs with complete translations, grammar explanations, 
                and cultural context. Music helps with pronunciation, rhythm, and natural language acquisition.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg border border-secondary-100">
              <h3 className="text-2xl font-display font-bold mb-4">Cultural Immersion</h3>
              <p className="text-gray-700 leading-relaxed">
                Explore Spanish-speaking cultures through films, recipes, travel guides, and authentic 
                dialogues. Understand not just the language, but the people and traditions behind it.
              </p>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg border border-primary-100">
              <h3 className="text-2xl font-display font-bold mb-4">Interactive Learning</h3>
              <p className="text-gray-700 leading-relaxed">
                Practice with interactive games, quizzes, and exercises designed for PC and mobile. 
                Learn vocabulary, grammar, and comprehension through engaging, fun activities.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-6">
              Our Team
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Passionate educators and cultural experts dedicated to your success
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-primary-50 to-secondary-50 border border-primary-100">
              <div className="w-32 h-32 bg-gradient-to-br from-primary-400 to-secondary-400 rounded-full mx-auto mb-4 flex items-center justify-center shadow-lg">
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Expert Tutors</h3>
              <p className="text-gray-600">
                Certified Spanish instructors with years of experience teaching English speakers
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-secondary-50 to-primary-50 border border-secondary-100">
              <div className="w-32 h-32 bg-gradient-to-br from-secondary-400 to-primary-400 rounded-full mx-auto mb-4 flex items-center justify-center shadow-lg">
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Content Creators</h3>
              <p className="text-gray-600">
                Native Spanish speakers who create authentic, culturally rich learning materials
              </p>
            </div>

            <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-primary-50 to-secondary-50 border border-primary-100">
              <div className="w-32 h-32 bg-gradient-to-br from-primary-400 to-secondary-500 rounded-full mx-auto mb-4 flex items-center justify-center shadow-lg">
              </div>
              <h3 className="text-xl font-display font-semibold mb-2">Tech Team</h3>
              <p className="text-gray-600">
                Developers building interactive games and platforms to enhance your learning experience
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20" style={{ backgroundColor: '#FF6B6B' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-white mb-6">
            Ready to Start Your Spanish Journey?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Join thousands of successful Spanish learners and discover the joy of learning through music and culture
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/store"
              className="bg-white text-primary-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-primary-50 transition transform hover:scale-105 shadow-lg"
            >
              Explore Products
            </Link>
            <Link
              to="/free-ebook"
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-primary-600 transition transform hover:scale-105"
            >
              FREE EBOOK
            </Link>
          </div>
        </div>
      </section>

      {/* Shared Footer */}
      <Footer />
    </div>
  );
}

export default AboutPage;
